// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/

/*
  In this CSS file we write common styles for application and App.js file's style also
  Ex: We write responsive UI also in this css file.
*/

.App {
  text-align: left;
}

.welcometext,
.loadingblock {
  text-align: center;
  vertical-align: middle;
  font-size: 30px;
  padding-top: 15%;
}

#root {
  height: 100vh;
  overflow: y auto;
  font-family: 'Roboto', sans-serif;
}

.Titlebar {
  height: 50px;
  width: 100%;
  background-color: #06053f;
  display: flex;
  align-items: center;
}

.title {
  color: white;
  font-size: 20px;
  margin: 0px 0px 0px 30px !important;
}
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f0f2f5;
  column-gap: 10px;
}

/* Card styling */
.login-card {
  background: #ffffff;
  padding: 40px 30px;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
}

/* Space between inputs and button */
.login-card > *:not(:last-child) {
  margin-bottom: 20px;
}

/* Optional: Style title */
.login-card-title {
  font-size: 1.5rem;
  margin-bottom: 25px;
  text-align: center;
  font-weight: 600;
  color: #333;
}
.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black; /* Add dots under the hoverable text */
  cursor: pointer;
}

/* Tooltip text */
.tooltiptext {
  visibility: hidden; /* Hidden by default */
  width: 130px;
  background-color: black;
  color: #ffffff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
  position: absolute;
  z-index: 1; /* Ensure tooltip is displayed above content */
}

/* Show the tooltip text on hover */
.tooltip:hover .tooltiptext {
  visibility: visible;
}
.access-button-wrapper {
  display: flex;
  gap: 10px;
}
.sub-rep {
  width: 500px !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/App.css"],"names":[],"mappings":"AAAA;;;CAGC;;AAED;;;CAGC;;AAKD;EACE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,WAAW;EACX,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,+BAA+B,EAAE,sCAAsC;EACvE,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB,EAAE,sBAAsB;EAC1C,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,UAAU,EAAE,8CAA8C;AAC5D;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,uBAAuB;AACzB","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n\n/*\n  In this CSS file we write common styles for application and App.js file's style also\n  Ex: We write responsive UI also in this css file.\n*/\n@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap');\n\n@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap');\n\n.App {\n  text-align: left;\n}\n\n.welcometext,\n.loadingblock {\n  text-align: center;\n  vertical-align: middle;\n  font-size: 30px;\n  padding-top: 15%;\n}\n\n#root {\n  height: 100vh;\n  overflow: y auto;\n  font-family: 'Roboto', sans-serif;\n}\n\n.Titlebar {\n  height: 50px;\n  width: 100%;\n  background-color: #06053f;\n  display: flex;\n  align-items: center;\n}\n\n.title {\n  color: white;\n  font-size: 20px;\n  margin: 0px 0px 0px 30px !important;\n}\n.login-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background-color: #f0f2f5;\n  column-gap: 10px;\n}\n\n/* Card styling */\n.login-card {\n  background: #ffffff;\n  padding: 40px 30px;\n  border-radius: 10px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-width: 400px;\n}\n\n/* Space between inputs and button */\n.login-card > *:not(:last-child) {\n  margin-bottom: 20px;\n}\n\n/* Optional: Style title */\n.login-card-title {\n  font-size: 1.5rem;\n  margin-bottom: 25px;\n  text-align: center;\n  font-weight: 600;\n  color: #333;\n}\n.tooltip {\n  position: relative;\n  display: inline-block;\n  border-bottom: 1px dotted black; /* Add dots under the hoverable text */\n  cursor: pointer;\n}\n\n/* Tooltip text */\n.tooltiptext {\n  visibility: hidden; /* Hidden by default */\n  width: 130px;\n  background-color: black;\n  color: #ffffff;\n  text-align: center;\n  padding: 5px 0;\n  border-radius: 6px;\n  position: absolute;\n  z-index: 1; /* Ensure tooltip is displayed above content */\n}\n\n/* Show the tooltip text on hover */\n.tooltip:hover .tooltiptext {\n  visibility: visible;\n}\n.access-button-wrapper {\n  display: flex;\n  gap: 10px;\n}\n.sub-rep {\n  width: 500px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
